import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import CustomAlert from '../../components/CustomAlert';
import CustomLoading from '../../components/CustomLoading';
import { paths } from '../../config/router.config';
import wsclients from '../../services/wsclients';
import t from '../../utils/translateUtil';
import { verify_id_number } from '../../utils/util';
import RegisterView from './RegisterView';
import jwt_decode from "jwt-decode";
import CustomRadioButtonGroup from '../../components/CustomRadioButtonGroup';
import { clearOrderCache, getAddressHome, getContactInfo, getDeviceInfo, getOrderInfoCache, getPackageInfo, getPaymentInfo, getUTMInfo, logOut, saveDataIntoAsyncStore, setAmountPayment, setContactInfo, setOrderInfoCache, setPaymentLinkInfo, setRegisterAttachments, setUTMInfo } from '../../utils/commons';
import CustomAlerts from '../../components/CustomAlerts';
import OrderProgress from '../orders/OrderProgress';
import { lab4services } from '../../services/wsclients/lab4services';
import ProcessFormView from './ProcessFormView';
import { httpUtil } from '../../services/wsclients/httpUtil';
import LinearBuffer from '../orders/LinearBuffer';
import { Grid, Typography } from '@mui/material';

//id number: 7707185170084

export default function RegisterControllerV2(props) {
    const history = useHistory();
    const [showLoading, onShowLoading] = useState(false);
    const [message, setMessage] = useState({});
    const [isSameHomeAddress, setSameHomeAddress] = useState(false);
    const [registerInfo, setRegisterInfo] = useState(getContactInfo() ? getContactInfo() : null);
    const [payment_selected, setPaymentSelected] = useState(null);
    const [options, setOptions] = useState([]);
    const [selectedDate, setSelectedDate] = useState(null);
    const [selected, setSelected] = useState('1');
    const [validations, setValidations] = useState({
        email: undefined,
        password: undefined,
    });
    const [showLoadingEmail, onShowLoadingEmail] = useState(false);
    const [showButtonClose, setShowButtonClose] = useState(false);
    const [focusField, setFocus] = useState(null);
    const [attachments, setAttachments] = useState([]);
    const [error, setError] = useState({
        showAlert: false,
        close: true,
        message: '',
        status: '',
    });
    const [htmlContent, setHtmlContent] = useState(null);
    const [openProcessForm, setOpenProcessForm] = useState(false);
    const [showProgressOrder, setShowProgressOrder] = useState(false);
    const [fileIdNumber, setFileIdNumber] = useState(null);
    const [filePassport, setFilePassport] = useState(null);
    const [isAgreeTerm, setAgreeTerm] = useState(false);

    const { t } = useTranslation();

    const package_info = getPackageInfo() ? getPackageInfo() : null;
    const address = getAddressHome() ? getAddressHome() : null;
    const [alerts, setAlerts] = useState([]);

    console.log("package_info==", package_info);
    console.log("address==", address);

    const dates = [
        {
            label: '1',
            value: '1',
        },
        {
            label: '16',
            value: '16',
        },
        {
            label: '21',
            value: '21',
        },
        {
            label: '26',
            value: '26',
        },
    ]

    useEffect(() => {
        const optionsBill = [
            {
                label: 'Prepaid 28 days non-recurring',
                value: '1',
            },
            {
                label: 'Monthly Recurring',
                value: '2',
                child: renderChild(dates),
            },
        ]
    }, []);

    const onChangeOption = (e) => {
        setSelected(e.target.value);
    }

    const onChangeDate = (e) => {
        setSelectedDate(e.target.value);
    }

    const renderChild = (items) => {
        return (
            <div style={{ marginLeft: 20 }}>
                {items && items.length > 0 &&
                    <CustomRadioButtonGroup
                        items={items}
                        selected={selectedDate ? selectedDate : null}
                        onChange={onChangeDate}
                    />
                }
            </div>
        );
    }

    const onShowMessage = (message) => {
        onShowLoading(false)
        setMessage(message)
        setShowProgressOrder(false);
    }

    const onHandleUpload = (target, files) => {
        console.log("files upload ===", files);
    }

    const onSameHomeAddress = () => {
        setSameHomeAddress(!isSameHomeAddress);
    }

    const onChangePayment = (event) => {
        setPaymentSelected(event.target.value);
    }

    const onCheckEmail = async (email) => {
        try {
            onShowLoadingEmail(true);
            console.log("email===", email.target.value);
            let result = await wsclients.lab4services.onCheckEmailAddress(email.target.value);
            console.log("onCheckEmailAddress result===", result);
            onShowLoadingEmail(false);
            if (result.code === 'OK') {
                if (result.data.result === 'VALID') {
                    setValidations({
                        ...validations,
                        email: false,
                    });
                    return undefined;
                }
            }
            setValidations({
                ...validations,
                email: true,
            })
            return t('Please enter a valid e-mail address');
        }
        catch (ex) {
            console.log("onCheckEmailAddress exception===", ex);
        }
    }

    const onHandleBlur = (value, target) => {
        let validPhone = false;
        let validPassword = false;
        let validIdNumber = false;
        let validConfirmPassword = false;
        if (target === 'phone') {
            if (!value || isNaN(value)) validPhone = true;
            else if (value && value.length !== 10) {
                validPhone = true;
            } else {
                if (value) {
                    let startItem = value.substr(0, 1);
                    if (startItem !== '0') {
                        validPhone = true;
                    }
                }
            }
            setValidations(prevState => ({
                ...prevState,
                phone: validPhone,
            }));
            return validPhone;
        }
        if (target === 'password') {
            if (!value) {
                validPassword = true;
            } else if (value && value.length < 8) {
                validPassword = true;
            }
            setValidations(prevState => ({
                ...prevState,
                password: validPassword,
            }));
            return validPassword;
        }
        if (target === 'id_number') {
            if (value && value.length !== 13) {
                validIdNumber = true;
            }
            else validIdNumber = verify_id_number(value) ? false : true;
            console.log("onvalidate id number ===", validIdNumber);
            setValidations(prevState => ({
                ...prevState,
                id_number: validIdNumber,
            }));
            return validIdNumber;
        }
        if (target === 'confirm_password') {
            if (!value) validConfirmPassword = true;
            else if (value && value.length < 8) {
                validConfirmPassword = true;
            }
            setValidations(prevState => ({
                ...prevState,
                confirm_password: validConfirmPassword,
            }));
            return validConfirmPassword;
        }
        return false;
    }

    const onSubmit = async (values) => {
        console.log("form register values===", values);
        onShowLoading(true);
        try {
            const { first_name, last_name, email_address, mobile_number, password, confirm_password, id_number, passport_number,
                street_number, street_name, town_city, postal_code, state_province_county, apartment_name, apartment_number } = values;
            if (id_number || passport_number) {
                let validEmail = onHandleBlur(email_address, 'email');
                let validPassword = onHandleBlur(password, 'password');
                let validIdNumber = passport_number ? false : onHandleBlur(id_number, 'id_number');
                let validConfirmPassword = onHandleBlur(confirm_password, 'confirm_password');
                let isCheckLocation = await onCheckLocation(address.premise_ref_isp);
                if(!isCheckLocation) return false;
                if (!validEmail && !validPassword && !validIdNumber && !validConfirmPassword) {
                    let contact_info = {
                        first_name: first_name,
                        last_name: last_name,
                        email: email_address,
                        password: password,
                        phone_number: mobile_number,
                        id_number: id_number,
                        passport_number: passport_number,
                        state_province_county: state_province_county,
                    }
                    let addressHome = {
                        street_number: street_number,
                        street_name: street_name,
                        town_city: town_city,
                        postal_code: postal_code,
                        apartment_name: apartment_name,
                        apartment_number: apartment_number,
                        state_province_county: state_province_county,
                    }
                    setRegisterInfo(contact_info);
                    setShowProgressOrder(true);
                    await onMakeOrderV2(contact_info, addressHome);
                    onShowLoading(false);
                    setShowButtonClose(true);
                }
            } else {
                onShowMessage({ show: true, content: t('MUST_INPUT_ID_OR_PASSPORT') })
            }
        }
        catch (error) {
            console.log("register EXCEPPPPTIONNNN", error);
            onShowMessage({ show: true, content: t('EXCEPTION') })
        }
        onShowLoading(false);
    }

    const wait = m => new Promise(r => setTimeout(r, m))

    const onUploadFile = async (filesContact, token) => {
        let _filesUploaded = [];
        try {
            console.log("filesContact:", filesContact)
            for (let i = 0; i < filesContact.length; i++) {
                const file = filesContact[i];
                const result = await wsclients.config.uploadFilesNew({ file: file, token: token });
                if (result.code == 'OK') {
                    if (result.data.id) _filesUploaded.push(result.data.id);
                } else if (result.data && result.data.error == 'COM.CRM.EXCEPTIONS.INVALIDFILETYPEEXCEPTION') {
                    showAlert({ status: true, message: t('INVALID_FILE_TYPE') })
                }
            }
        } catch (error) {
            console.log("onUploadFile exception:", error);
        }
        return _filesUploaded
    }

    const onAddFilesContact = async (filesUploaded) => {
        try {
            for (let i = 0; i < filesUploaded.length; i++) {
                await wsclients.lab4services.onUploadFile(filesUploaded[i]);
            }
            await setAttachments([]);
        } catch (error) {
            console.log("onAddSRAttachment exception:", error);
        }
    }

    const showAlert = (status, message, close) => {
        onShowLoading(false);
        setMessage({
            showAlert: true,
            message: message,
            status: status,
            close: close
        });
    }

    const onCloseAlert = () => {
        onShowLoading(false);
        setError({
            showAlert: false,
            message: '',
            status: '',
            close: true
        });
    }

    const onAddImage = (target, files) => {
        console.log("AAAAAa onUploadFile ===");
        console.log("files onAddImage===", files);
        if (files && files.length > 0) {
            if (target === 'id_number') setFileIdNumber(files[0]);
            else if (target === 'passport_number') setFilePassport(files[0]);
            else setAttachments(files)
            setRegisterAttachments(files);
        }
    }

    const onMakeOrderV2 = async (contact_info, addressHome) => {
        try{
            let body = {
                product_id: package_info && package_info.id ? package_info.id : null,
                location_reference: address && address.premise_ref_isp ? address.premise_ref_isp : null,
                product_reference: package_info && package_info.sku ? package_info.sku : null,
                payment_redirect_url: window.location.origin + paths.orders_result,
                is_recuring: package_info && package_info.is_recuring ? package_info.is_recuring : false,
                recurring_payment_date: package_info && package_info.recurring_payment_date ? package_info.recurring_payment_date : null,
                product_type: package_info && package_info.product_type ? package_info.product_type : null,
                order_amount: package_info && package_info.price ? package_info.price : 0,            
            }
            let contact = {
                first_name: contact_info.first_name ? contact_info.first_name : null,
                last_name: contact_info.last_name ? contact_info.last_name : null,
                id_number: contact_info.id_number,
                passport_number: contact_info.passport_number,
                identity: {
                    username: contact_info.email ? contact_info.email : null,
                    password: contact_info.password ? contact_info.password : null,
                    validation_required: false,
                },
                phone_number: contact_info.phone_number,
                country_code: 'ZAF',//hardcode,
                service_acceptance: true,
                email_opt_out: false,
                sms_opt_out: false,
                address: {
                    // address_type: 'HOME',
                    address_line_1: addressHome.street_number + ", " + addressHome.street_name,
                    address_line_2: address && address.suburb ? address.suburb : null,
                    state_province_county: addressHome.state_province_county ? addressHome.state_province_county : null,
                    town_city: addressHome.town_city,
                    postal_code: addressHome.postal_code,
                    lat: address && address.latitude ? address.latitude : null,
                    lon: address && address.longitude ? address.longitude : null,
                    apartment_name: addressHome.apartment_name ? addressHome.apartment_name : null,
                    apartment_number: addressHome.apartment_number ? addressHome.apartment_number : null,
                    vumatel_premise_id: address && address.premisesid ? address.premisesid : null,
                    network_type: address && address.networktype ? address.networktype : null,
                }
            }
            let deviceInfo = getDeviceInfo();
            if(package_info && package_info.product_type === 'vuma_core' && deviceInfo){
                contact.device_name = deviceInfo.name ? deviceInfo.name : null;
            }
            body.contact = contact;
            let utm_info = getUTMInfo();
            if(utm_info && utm_info.utm_source && utm_info.utm_campain){
                body.utm_source = utm_info.utm_source;
                body.utm_campain = utm_info.utm_campain;
            }
            // debugger;
            let result = await lab4services.makeOrderV2(body);
            console.log("AAAA onMakeOrderV2 result: ", result);
            if(result.code == 'OK'){
                setUTMInfo(null)
                if(result.data.access_token) {
                    httpUtil.startSession({
                        access_token: result.data.access_token,
                    })
                }
                if(package_info.product_type == 'vuma_core'){
                    setPaymentLinkInfo({
                        type: 'register',
                        ...result.data,
                    });
                    setContactInfo({
                        id: result.data.contact_id,
                        email: contact_info.email,
                        code: result.data.contact_code,
                    });
                    await initPayment();
                } else {
                    clearOrderCache();
                    await wait(2000);
                    window.location.href = result.data.vumatel_payment_url;
                }
            } else if(result.code == 'LOCATION_REFERENCE_IS_NOT_AVAILABLE'){
                onShowMessage({
                    show: true, 
                    content: t('address_used')
                });
                return false;
            } else if (result.code === 'CREATE_CRM_ORDER_EXCEPTION'){
                onShowMessage({
                    show: true, 
                    content: t('CREATE_CRM_ORDER_EXCEPTION')
                });
                return false;
            } else if (result.data && result.data.error && result.data.error.error == 'ORDER_FOR_CONTACT_IS_ALREADY_EXIST'){
                onShowMessage({
                    show: true, 
                    content: t('ORDER_FOR_CONTACT_IS_ALREADY_EXIST')
                });
                return false;
            } else if(result.data && result.data.error && result.data.error.error == 'ID_NUMBER_OR_PASSPORT_ALREADY_EXIST'){
                onShowMessage({
                    show: true, 
                    content: t('ID_NUMBER_OR_PASSPORT_ALREADY_EXIST')
                });
                return false;
            }
            else {
                let entity = result.data && result.data.error && result.data.error.entity ? JSON.parse(result.data.error.entity) : null;
                let message = entity && entity.detail && typeof (entity.detail) === 'string' ? entity.detail : t('CREATE_ORDER_FAILED');
                onShowMessage({
                    show: true, 
                    content: message
                });
            }
        }catch(ex){
            console.log("AAAA onMakeOrderv2 exception: ", ex);
            onShowMessage({
                show: true, 
                content: t('CREATE_ORDER_FAILED')
            });
        }
    }

    const initPayment = async () => {
        try {
            let contact_info = getContactInfo();
            let amount = package_info && package_info.price ? package_info.price : null;
            setAmountPayment(amount);
            let body = {
                contact_id: contact_info && contact_info.id ? contact_info.id : null,
                email_address: contact_info && contact_info.email ? contact_info.email : null,
                contact_code: contact_info && contact_info.code ? contact_info.code : null,
                amount: amount,
            };
            let result = await lab4services.initPayment(body);
            console.log("result initPayment ===", result);
            if (result.code === 'OK') {
                let urlFormPaygate = document._portalConfig.urlFormPaygate;
                if (result && result.code === 'OK' && result.data && result.data.client_token) {
                    let clientToken = result.data.client_token;
                    var splitToken = clientToken.split("_zjjjvjgqhmnyzgqy_");
                    console.log('splitToken:', splitToken);
                    if (splitToken.length > 0) {
                        var payRequestIDRes = splitToken[0];
                        var checkSumRes = splitToken[1];
                        var htmlContent = '<form name="paymentForm" action="' + urlFormPaygate + '" method="POST">'
                            + '<input type="hidden" name="PAY_REQUEST_ID" value="' + payRequestIDRes + '">'
                            + '<input type="hidden" name="CHECKSUM" value="' + checkSumRes + '">'
                            + '</form>'
                        console.log('htmlContent:', htmlContent);
                        setHtmlContent(htmlContent);
                        setOpenProcessForm(true);
                        setShowProgressOrder(false);
                    }
                } else if (result.data && result.data.state === 'REJECTED') {
                    onShowMessage({
                        show: true,
                        message: t('INIT_PAYMENT_REJECTED'),                    
                        action: async () => await initPayment(),
                        okTitle: t('btn_try'),
                        cancelTitle: t('btn_close'),
                    })
                }
            } else {
                onShowMessage({
                    show: true,
                    message: t('INIT_PAYMENT_FAILED'),                    
                    action: async () => await initPayment(),
                    okTitle: t('btn_try'),
                    cancelTitle: t('btn_close'),
                });
                return false;
            }
        } catch (ex) {
            console.log("initPayment exception ===", ex);
        }
    }

    const onCheckLocation = async (location_id) => {
        let isAllowLocation = false;
        try {
            let result = await lab4services.checkLocationAvaibleOrder(location_id);
            console.log("AAAA onCheckLocation result: ", result);
            if (result.code == 'OK') {
                if (result.data && result.data.is_available_create_order) {
                    isAllowLocation = true;
                } else {
                    onShowMessage({
                        show: true,
                        message: result.data && result.data.descriptions ? result.data.descriptions : t('address_used')
                    });
                    isAllowLocation = false;
                }
            }
        } catch (ex) {
            console.log("AAAA onCheckLocation exception: ", ex);
        }
        return isAllowLocation;
    }

    const onConfirmProcess = async (values) => {
        console.log("AAAA values: ", values)
        if(package_info && package_info.product_type == 'vuma_core'){
            onShowMessage({
                show: true,
                content: t('agree_term_message'),
                isConfirm: true,
                confirmAction: {
                    okAction: async () => {
                        onShowMessage({});
                        await onSubmit(values)
                    },
                    okTitle: t('Agree'),
                    cancelAction: () => onShowMessage({}),
                },
                title: t('Information Consent')
            })
        } else {
            await onSubmit(values);
        }
    }

    return (
        <div>
            <RegisterView
                isSameHomeAddress={isSameHomeAddress}
                payment_selected={payment_selected}
                options={options}
                selected={selected}
                address={address}
                validations={validations}
                showLoadingEmail={showLoadingEmail}
                focusField={focusField}
                registerInfo={registerInfo}
                isAgreeTerm={isAgreeTerm}
                // showProgressOrder={showProgressOrder}
                onSameHomeAddress={onSameHomeAddress}
                onHandleUpload={onHandleUpload}
                onChangePayment={onChangePayment}
                onSubmit={onConfirmProcess}
                onChangeOption={onChangeOption}
                onCheckEmail={onCheckEmail}
                onHandleBlur={onHandleBlur}
                onAddImage={onAddImage}
                setAgreeTerm={setAgreeTerm}
            />
            {alerts && alerts.length > 0 && <CustomAlerts alerts={alerts} />}
            {message.show && <CustomAlert
                open={message.show}
                message={message.content}
                showButtonClose={true}
                isConfirm={message.isConfirm ? message.isConfirm : null}
                confirmAction={message.confirmAction ? message.confirmAction : null}
                onClose={message.action ? message.action : () => onShowMessage({})}
                okTitle={message.okTitle}
                cancelTitle={message.cancelTitle}
                title={message.title}
            />}
            {showLoading && <CustomLoading open={showLoading} />}
            {openProcessForm && <ProcessFormView
                open={openProcessForm}
                onClose={() => setOpenProcessForm(false)}
                html_content={htmlContent}
            />}
            {showProgressOrder && <CustomAlert
                open={showProgressOrder}
                title={t('progress_order')}
                maxWidth='sm'
                title_close={t('btn_close')}
                customMessage={<>
                    <Grid item xs={12}>
                        <LinearBuffer status={'IN_PROGRESS'}/>
                        <Typography>{t('warning_progress_order')}</Typography>
                    </Grid>
                </>}
            />}
        </div>
    );
}